.scope {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.75rem;
}

/* Owner round 3: what moving changes, on its own line above the field. */
.explain {
  flex-basis: 100%;
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-12);
}
